<template>
    <div>
      <div v-if="pagine_web && header_accessori.val('image')" :style="{'background-image': 'url(' + header_accessori.val('image').link() + ')'}" class="collections-hero">
        <h2 class="text-center" v-html="header_accessori.val('titolo')"> </h2>
      </div>
      <div v-else style="background-image:url('/collezioni/placeholder.png')" class="collections-hero">
        <h2 class="text-center"> {{ "Accessori" }} </h2>
      </div>
      <div
      class="d-flex justify-content-center align-items-start box-dual-ring"
      v-if="initial_loading"
      >
        <div class="lds-dual-ring"></div>
      </div>
      <div v-else class="container">
        <div class="breadcrumb py-3">
          <a href="/"> {{ 'Home' }} </a>
          <span> {{ ' / ' }} </span>
          <p> {{ 'Accessori' }} </p>
        </div>
        <div class="pt-5 text-center lh-lg">
          <p v-if="header_accessori" v-html="header_accessori.val('descrizione_introduttiva')"></p>
          <p v-else>{{ "No header accessori" }}</p>
        </div>
        <template v-for="a in accessori" :key="a.id">
          <div class="collection-card-box col-12 d-flex flex-lg-row flex-column mb-5 mt-5">
            <div class="col-lg-6 col-12">
              <img v-if="(a.val('image'))" class="img-fluid" :src="a.val('image').link({'x':600,'y':600,'ext':'jpg'})">
              <img v-else class="img-fluid" src="/collezioni/placeholder.png">
              </div>
            <div class="collection-content col-lg-6 col-12 p-4">
              <div class="article-title"><h2 class="fw-lighter lh-1">{{ a.val("nome") }}</h2></div>
              <div class="collection-desc mb-3"><p>{{ a.val("descrizione") }}</p></div>
              <div @click="goToPage($router.resolve({ name: 'accessori', params: { gamma: a.val('nome') } }).href)"  class="anchor-img mt-4 d-flex">
                SCOPRI LA GAMMA <img class="ms-3" src="/icone/freccia_prodotti.svg" alt="freccia">
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </template>
  
  <script lang="js">
  import { defineComponent } from "@vue/runtime-core";
  import { Schema } from "onpage-js";
  
  export default defineComponent({
    props: {
      schema: {
        type: Schema,
        required: true,
      },
      pagine_web: {
        required: true,
      }
    },
    data() {
      return {
        accessori: null,
        pagina_web_accessori: null,
        header_accessori: null,
        immagine_header_accessori: null,
        cerca: "",
        correct_img: null,
        initial_loading: false,
      };
    },
    async created() {
      this.initial_loading = true;
  
      if(this.initial_loading){
        this.refreshAccessori().then(()=>{
          this.initial_loading = false;
          this.getPreviewAccessori();
        })
      } else {
        this.initial_loading = true;
      }
      
    },
    async mounted(){


      window.document.getElementById('app').scrollIntoView()

      // if(this.pagine_web && this.accessori){
      //   this.getPreviewAccessori();
      // }
    },
    computed: {
      accessori_query(){
        const schema = this.schema;
        if (!schema) return;
        const q = schema.query("accessori");
        return q;
      },
    },
    methods: {
      goToPage(path) {
        console.log(path)
        this.$router.push({ path: `/${path.replace('#/', '')}` })
      },
      async refreshAccessori() {
        this.accessori = await this.accessori_query.all();
      },
      getPreviewAccessori(){
      this.pagina_web_accessori = this.pagine_web.filter(x => x.val("nome") == "Accessori");
      this.header_accessori = this.pagina_web_accessori[0].relSync("header")[0];
      }
    },
    watch: {
      pagine_web(){
      if(this.pagine_web && this.accessori){
        this.getPreviewAccessori();
      }
    }
    }
  });
  </script>
  
  
  <style>
  *{
    margin: 0;
    padding: 0;
    font-family: 'Poppins', sans-serif;
  }
  .container{
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .collections-hero{
    width: 100%;
    height: 700px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .collections-hero h2{
    font-size: 42px;
    font-weight: 300;
    color: #fff;
  }
  .collections-hero h2 span{
    font-weight: 200;
    text-transform: uppercase;
  }
  .collection-card{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items:center;
    margin: 0 auto;
  }
  .article-title h2{
    font-size: 80px;
    color: #646363;
  }
  .collection-sub{
    font-size: 32px;
  }
  .collection-desc{
    font-size: 1rem;
    color: #646363;
  }
  .collection-card-box:nth-child(odd){
    flex-direction: row-reverse !important;
  }
  .collection-content{
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .ideas-anchor, .anchor-img{
    color: #000;
    text-decoration: none;
  }
  .anchor-img{
    font-size: 1.2rem;
  }
  .ideas-anchor:hover{
    color: #000;
  }
  .anchor-img:hover{
    color: #000;
    transform: translate(10px);
    transition: all 200ms ease-in-out;
  }
  .divider{
    padding-bottom: 20px;
    border-bottom: 1px solid #000;
  }
  .collection-horizontal-title{
    font-size: 42px;
  }
  .collection-horizontal-par{
    font-size: 32px;
  }
  .all-prods a{
    width: 100%;
  }
  .anchor-img img{
    width: 50px;
  }
  .all-prods-left h4, .all-prods-left p{
    font-size: 32px;
    font-weight: 600;
  }
  .all-prods-left p{
    font-weight: 300;
    margin-bottom: 0;
  }
  .all-prods{
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .lds-dual-ring{
    margin-top: 100px;
  }
  .breadcrumb{
    font-size: 14px !important;
    color: #646363;
  }
  .breadcrumb a{
    color: #646363;
  }
  .breadcrumb a:hover{
    color: #000;
  }
  
  @media (max-width: 1024px){
    .collections-hero{
      height: 400px;
    }
  }
  @media (max-width: 991px){
    .collection-card-box:nth-child(odd){
    flex-direction: column !important;
  }
  }
  </style>
  